const USE_REMOTE = false;
const REMOTE_URL = 'https://ahtesting.tagesspiegelinnovationlab.site/api/log/';


const logLevels = {
  DEBUG: 0,
  INFO: 1,
  WARN: 2,
  ERROR: 3,
};

let logLevel = 'ERROR';

export function setLogLevel(l) {
  logLevel = l;
}

export class Logger {
  constructor(prefix) {
    this.prefix = prefix;
  }

  print(msg, level) {
    const msgOut = `${this.prefix} [${level}]: ${msg}`;
    let fct = console.log;
    if (level === 'WARN') fct = console.warn;
    if (level === 'ERROR') fct = console.error;
    if (logLevels[level] >= logLevels[logLevel]) fct(msgOut);

    if (USE_REMOTE) {
      const xhr = new XMLHttpRequest();
      xhr.open('POST', REMOTE_URL, true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify({
        user: window.AH_USER || 'local',
        msg: msgOut,
      }));
    }
  }

  debug(msg) { return this.print(msg, 'DEBUG'); }
  info(msg) { return this.print(msg, 'INFO'); }
  warn(msg) { return this.print(msg, 'WARN'); }
  error(msg) { return this.print(msg, 'ERROR'); }
}
